import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=268694a6&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268694a6')) {
      api.createRecord('268694a6', component.options)
    } else {
      api.reload('268694a6', component.options)
    }
    module.hot.accept("./Activate.vue?vue&type=template&id=268694a6&", function () {
      api.rerender('268694a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Activate.vue"
export default component.exports